module.exports = __webpack_public_path__ + "img/Frente-50-01 on.c1475f79.png";